import { LoadingActionTypes, SET_LOADING } from './actionTypes';

export const setLoading = (loading: boolean): LoadingActionTypes => ({
    type: SET_LOADING,
    payload: loading
});